import { useState } from 'react';
import { AtSign, Info, KeyRound, Reply, Save } from 'lucide-react';
import { Button, Input, SettingsSection } from '@/design-system';
import type { ResendSettingsData } from '../../api/resend-settings.service';
import { useResendSettings } from '../../hooks/useResendSettings';
import { SecretSettingsInput } from '../SecretSettingsInput';

export function ResendSection() {
  const { query, save } = useResendSettings();
  const [draft, setDraft] = useState<Partial<ResendSettingsData>>({});
  if (query.isPending) return <p role="status" className="text-sm text-gray-500">Carregando Resend…</p>;
  if (!query.data) return <div role="alert" className="space-y-3 text-sm text-red-700">Não foi possível carregar o Resend.
    <Button variant="subtle" onClick={() => void query.refetch()}>Tentar novamente</Button></div>;
  const data = { ...query.data, ...draft };
  const patch = (partial: Partial<ResendSettingsData>) => { setDraft((previous) => ({ ...previous, ...partial })); save.reset(); };
  return <div className="space-y-5">
    {save.isError && <p role="alert" className="text-sm text-red-700">Não foi possível salvar o Resend. Tente novamente.</p>}
    {save.isSuccess && <p role="status" className="text-sm text-emerald-700">Configurações salvas.</p>}
    <fieldset disabled={save.isPending} className="min-w-0 space-y-5">
      <SettingsSection title="Chave de API" icon={KeyRound}>
        <p className="pt-4 text-sm text-gray-500">Obtenha sua chave em <a href="https://resend.com/api-keys" target="_blank" rel="noopener noreferrer" className="text-primary underline">resend.com/api-keys</a>.</p>
        <div className="pt-4"><SecretSettingsInput label="API Key" value={data.apiKey ?? ''} placeholder="re_..."
          onChange={(value) => patch({ apiKey: value })} /></div>
      </SettingsSection>
      <SettingsSection title="Remetente" icon={AtSign} description="O domínio deve estar verificado no Resend antes de enviar emails.">
        <div className="pt-4"><Input label="Endereço do remetente" value={data.fromAddress ?? ''} onChange={(event) => patch({ fromAddress: event.target.value })} />
          <p className="mt-1 text-xs text-gray-500">Formato: “Nome &lt;email@dominio.com&gt;” ou apenas “email@dominio.com”.</p></div>
      </SettingsSection>
      <SettingsSection title="Endereço de resposta (opcional)" icon={Reply} description="Para onde vão as respostas dos usuários. Vazio = usa o remetente.">
        <div className="pt-4"><Input label="Endereço de resposta" type="email" value={data.replyTo ?? ''} onChange={(event) => patch({ replyTo: event.target.value })} /></div>
      </SettingsSection>
    </fieldset>
    <div className="flex items-start gap-2 rounded-lg border border-gray-200 bg-white px-4 py-3 text-sm text-gray-600">
      <Info size={16} className="mt-0.5 shrink-0" />Configurações aplicam após salvar (cache de 60s). Sem necessidade de reiniciar o servidor.
    </div>
    <div className="flex justify-end"><Button isLoading={save.isPending} disabled={!Object.keys(draft).length}
      onClick={() => save.mutate(draft, { onSuccess: () => setDraft({}) })}><Save size={16} />Salvar configurações</Button></div>
  </div>;
}
